/* ==========================================================================
   NEW SPLASH PAGE
   Loaded on the index template only (see layout/theme.liquid)
   ========================================================================== */


/* ==========================================================================
   HERO
   Fades through the slides by moving the is_active class.
   Delay comes from the section's data-delay (seconds).
   ========================================================================== */

function setupSplashHero(hero) {
  var slides = hero.querySelectorAll('.splash_hero_slide');
  var delay = parseFloat(hero.dataset.delay) * 1000;
  var current = 0;
  var timer = null;

  function showSlide(index) {
    slides[current].classList.remove('is_active');
    current = index;
    slides[current].classList.add('is_active');
  }

  function stop() {
    clearInterval(timer);
  }

  function start() {
    stop();
    if (slides.length < 2) return;
    timer = setInterval(function () {
      showSlide((current + 1) % slides.length);
    }, delay);
  }

  // Theme editor: show the slide block that was clicked, resume when deselected
  hero.addEventListener('shopify:block:select', function (event) {
    stop();
    slides.forEach(function (slide, index) {
      if (slide.dataset.blockId === event.detail.blockId) showSlide(index);
    });
  });
  hero.addEventListener('shopify:block:deselect', start);

  hero.splashHeroStop = stop;
  start();
}

document.querySelectorAll('.splash_hero').forEach(setupSplashHero);

// Theme editor: set up a hero again when its section is re-rendered
document.addEventListener('shopify:section:load', function (event) {
  var hero = event.target.querySelector('.splash_hero');
  if (hero) setupSplashHero(hero);
});
document.addEventListener('shopify:section:unload', function (event) {
  var hero = event.target.querySelector('.splash_hero');
  if (hero && hero.splashHeroStop) hero.splashHeroStop();
});
